import { mergeNamespacedTranslations } from '../utils';

const context = require.context('./', true, /\/(\w{2}|\w{2}_\w{2})\/index.js$/);
const translations = mergeNamespacedTranslations(context)(context.keys());

export const availableTranslations = Object.keys(translations);
export default translations;
